import React from "react";

const TABS = [
  ["inside", "Currently Inside"],
  ["today", "Today's Appointments"],
  ["log", "Full Log"],
];

/** Simple tab bar. Purely visual; the parent owns the active-tab state. */
export default function VisitorsTabs({ active, onChange }) {
  return (
    <div className="flex gap-2 border-b border-[#E4DFCF]" data-testid="visitors-tabs">
      {TABS.map(([k, l]) => (
        <button
          key={k}
          onClick={() => onChange(k)}
          className={`px-3 py-2 text-sm ${
            active === k
              ? "border-b-2 border-[#0F5E39] text-[#0F1E15] font-medium"
              : "text-[#4A5A50]"
          }`}
          data-testid={`visitor-tab-${k}`}
        >{l}</button>
      ))}
    </div>
  );
}
